export type UpdateComponentDeploymentRequestsRequest = {
  dplymntReqSeqList: DplymntReqSeq[];
  dplyImplType: string;
  dplymntDtime?: string;
  forceStgDplyFlg: boolean;
};

export type DplymntReqSeq = {
  dplymntReqSeq: string;
  updateDtimeTDplymntReqMng: string;
};
